import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-field_text",
  "use": "icon-field_text-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-field_text\"><defs><style type=\"text/css\"></style></defs><path d=\"M554.666667 256v640h-85.333334V256H213.333333V170.666667h597.333334v85.333333z\" p-id=\"6355\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol